import { AppHeader } from "../../header/AppHeader";
import BackgroundTasks from "../../../common/hocs/BackgroundTasks";
import Routers from "../../../Routers";

type Props = {
  isAdmin: boolean;
};
export const AppRouterContent = ({ isAdmin }: Props) => {
  return (
    <>
      {isAdmin && <AppHeader />}
      <BackgroundTasks>
        <Routers />
      </BackgroundTasks>
    </>
  );
};
